import React, { useEffect, useRef } from 'react';

//Feather
import {
  Trash,
  CornerUpRight
} from 'react-feather';

//Momentjs
import moment from 'moment';
import 'moment/locale/pt-br';

//Svg's components
import File from '../svgs/File';
import MessageSearch from '../svgs/MessageSearch';

import { useAuth } from "../providers/auth";
import CustomerWarning from './CustomerWarning';
import LoadingCenter from './LoadingCenter';

const SearchMessages = ({ messages, isLoading, setMessageIdChat }) => {

  const { user } = useAuth();

  function setMessageId(id) {
    setMessageIdChat(id);
  }

  const renderMessageByType = (message, index) => {

    switch (message.type) {

      case "text": {
        return (
          <li key={index}>
            <a href={"#message-id-"+message.id} style={{ paddingTop: "10px", paddingBottom: "15px", cursor: "pointer" }} onClick={e => setMessageId(message.id)}>
              <span style={{ margin: "5px 20px" }} className={`message-box-date ${message.sender_id === String(user.id) ? "text-right" : "text-left"}`}>
                {moment(message.createdAt).format("LL")}
              </span>

              <div key={index} className={`message-box  ${message.starred && "msg-starred"} ${message.sender_id === String(user.id) ? "right" : "left"}`} id={"message-id-" + message.id}>

                {message.forward && <div>
                  <span>
                    <CornerUpRight fontSize={16} />
                  </span>

                  {message.forward === "forwarded" && <span className="text-bold ml-10">Mensagem encaminhada</span>}
                  {message.forward === "frequently_forwarded" && <span className="text-bold ml-10">Mensagem encaminhada com frequência</span>}
                </div>}


                {message.deleted && <div className="deleted-text mb-10">
                  <Trash size={18} />

                  <span className="ml-10">
                    Mensagem excluída
                  </span>
                </div>}
                <p>{message.body}</p>
                <span className="message-box-hour">{moment(message.createdAt).format("LT")}</span>
              </div>
            </a>
          </li>
        );
      }
    }
  }

  const warning = isLoading ? <LoadingCenter /> : <CustomerWarning title="Mensagens" subtitle="Pesquise por alguma mensagem específica.">
    <MessageSearch />
  </CustomerWarning>;

  return (
    <ul className="ul-messages clear-ul">
      {messages && messages.map((message, index) => renderMessageByType(message, index))}

      {warning}
    </ul>
  );
}

export default SearchMessages;